import { c as _c } from "react/compiler-runtime";
import { SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MEDIA_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';
import type { SpartanProductExteriorThreesixtyMediaStageProps } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/media-stage/types';
import { cn } from '@/app/utils/cn';
export const SpartanProductExteriorThreesixtyMediaStage = t0 => {
  const $ = _c(17);
  const {
    ref,
    mediaRef,
    children,
    className,
    mediaClassName,
    isMobileCropped: t1
  } = t0;
  const isMobileCropped = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("relative flex w-full items-center justify-center overflow-clip", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mediaClassName) {
    t3 = cn("shrink-0", SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MEDIA_CLASS_NAME, mediaClassName);
    $[2] = mediaClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMobileCropped) {
    t4 = cn("relative size-full", {
      "max-lg:absolute max-lg:top-[-3%] max-lg:left-[-3%] max-lg:h-[106%] max-lg:w-[106%] max-lg:max-w-none": isMobileCropped
    });
    $[4] = isMobileCropped;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <div className="relative size-full overflow-clip"><div className={t4}>{children}</div></div>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== mediaRef || $[10] !== t3 || $[11] !== t5) {
    t6 = <div ref={mediaRef} className={t3}>{t5}</div>;
    $[9] = mediaRef;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== ref || $[14] !== t2 || $[15] !== t6) {
    t7 = <div ref={ref} className={t2}>{t6}</div>;
    $[13] = ref;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};